import { routerSelectors } from 'src/app/core/router/router.selectors'

import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { SerieProposalItem } from './serie-proposal-item'
import * as fromSerieProposalItem from './serie-proposal-item.reducer'

const state =
  createFeatureSelector<fromSerieProposalItem.SerieProposalItemState>(
    fromSerieProposalItem.FEATURE_NAME
  )

const adapter = fromSerieProposalItem.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)
const selectIsLoading = createSelector(state, (state) => state.isLoading)
const selectPartials = createSelector(state, (state) => state.partials)
const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<SerieProposalItem>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (
    entities: SerieProposalItem[],
    filter?: { field: string; value: string | number }
  ) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectIdRouteParam = createSelector(
  routerSelectors.selectRouteParams,
  (params) => {
    return params && params.serieProposalItemId
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)

export const selectTotal = createSelector(
  selectAll,
  (serieProposalItems, saleId: number) => {
    return serieProposalItems
      .filter((serieProposalItem) => serieProposalItem.saleId == saleId)
      .reduce(
        (total, serieProposalItem) =>
          parseFloat(total) + parseFloat(serieProposalItem.totalPrice),
        '0'
      )
  }
)

export const serieProposalItemSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectPartials,
  selectIdRouteParam,
  selectCount,
  selectTotal
}
